import { BrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import OtpPromptHost from "./components/auth/OtpPromptHost";


const OwnerPendingHost = __DOMAIN_FOREX__ ? lazy(() => import("./pages/forex/components/OwnerPendingHost")) : null;

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <OtpPromptHost />
        {OwnerPendingHost && <Suspense fallback={null}><OwnerPendingHost /></Suspense>}
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
